import { autoinject, transient } from "aurelia-dependency-injection";
import { RightStoreService } from "../../../../../services/rightstore/rightstore.service";
import { OrderModel } from "../../../../../models/rightstore/rightstore.models";
import { useView } from "aurelia-framework";

@autoinject()
@transient()
@useView('views/pages/modules/orders/video/video.html')
export class Video {

    public youtubeUrl: string;
    public productName: string;

    constructor(private rightStoreService: RightStoreService){}

    async activate(args: { orderGuid }) {
        const orderGuid = args.orderGuid;   

        const orderResponse = await this.rightStoreService.getOrder(orderGuid);
        const order: OrderModel = orderResponse.order;

        this.productName = order.product.name;

        const videoId = order.product.variantAttributes[0].value;
        this.youtubeUrl = `https://www.youtube.com/embed/${videoId}`        
    }
}